import { useLiveQuery } from 'dexie-react-hooks'
import { offlineDb } from './db'
import { enqueue, type EnqueueItem } from './queueOps'

export type { EnqueueItem }

export function useMutationQueue() {
  const items =
    useLiveQuery(() => offlineDb.mutationQueue.orderBy('createdAt').toArray(), []) ?? []

  async function dequeue(id: number): Promise<void> {
    await offlineDb.mutationQueue.delete(id)
  }

  async function markRetry(id: number): Promise<void> {
    const item = await offlineDb.mutationQueue.get(id)
    if (item) {
      await offlineDb.mutationQueue.update(id, { retryCount: item.retryCount + 1 })
    }
  }

  async function clearAll(): Promise<void> {
    await offlineDb.mutationQueue.clear()
  }

  return {
    items,
    pendingCount: items.length,
    enqueue,
    dequeue,
    markRetry,
    clearAll,
  }
}

export type { OfflineEntity, OfflineOperation } from './db'
